import * as React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import "./TherapistSearch.scss";
import { getPracticeAdminUsersV1 } from "../../../../api/user";
import CustomTextField from "../../../../components/modules/ClinitianAvailabilityFilter/CustomTextField";
import _ from "lodash";

export default function TherapistSearch({ onSelected }) {
    const [value, setValue] = React.useState(null);
    const [inputValue, setInputValue] = React.useState("");
    const [options, setOptions] = React.useState([]);
    const [loading, setLoading] = React.useState(false);

    const fetchTherapists = async (searchString) => {
        const requestPayload = {
            user_type: "THERAPIST",
            keyword: searchString,
        };

        setLoading(true);
        const { users } = await getPracticeAdminUsersV1(requestPayload);

        setOptions(users);
        setLoading(false);
    };

    React.useEffect(() => {
        if (inputValue && inputValue.length > 2) {
            fetchTherapists(inputValue);
        } else {
            setOptions([]);
        }
    }, [inputValue]);

    React.useEffect(() => {
        onSelected(value);
    }, [value]);

    const onChangeInputValue = _.debounce((newInputValue) => {
        setOptions([]);
        setInputValue(newInputValue);
    }, 500);

    return (
        <div className="therapist-autocomplete-search">
            <Autocomplete
                id="google-map-demo"
                sx={{ width: 270, m: 1 }}
                getOptionLabel={(option) => option.full_name || option.email}
                filterOptions={(x) => x}
                options={options}
                autoComplete={true}
                includeInputInList={true}
                filterSelectedOptions={true}
                disableCloseOnSelect={false}
                value={value}
                noOptionsText="No therapist"
                onChange={(event, newValue) => {
                    setValue(newValue);
                }}
                onInputChange={(event, newInputValue) => {
                    onChangeInputValue(newInputValue);
                }}
                isOptionEqualToValue={(option, value) =>
                    option.email === value.email
                }
                loading={loading}
                renderInput={(params) => (
                    <CustomTextField
                        {...params}
                        label="Search therapists"
                        variant="filled"
                        fullWidth={true}
                    />
                )}
            />
        </div>
    );
}
